// extracted by mini-css-extract-plugin
module.exports = {"root":"RelatedPersons_root__S3LMk","item":"RelatedPersons_item__3kW7F"};